import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../components/services/useAuth";
import userSession from "../../../components/services/UserSession";
import "../dashboard/Dashboard.css";
import LeftMenu from "../leftmenu/LeftMenu";
import SqlTutorWidget from "../student/tutor/SqlTutorWidget";

const studentNavItems = [
  { name: "Dashboard", address: "/dashboard", icon: "fa-tachometer-alt" },
  { name: "Cohorts", address: "/dashboard/cohorts", icon: "fa-users" },
  { name: "Assignments", address: "/dashboard/assignments", icon: "fa-book" },
  { name: "Quizzes", address: "/dashboard/quizzes", icon: "fa-question" },
  { name: "Submission", address: "/dashboard/results", icon: "fa-chart-area" },
  { name: "SQL Tutor", address: "/dashboard/tutor", icon: "fa-robot" },
  { name: "Profile", address: "/dashboard/profile", icon: "fa-user" },
];

const teacherNavItems = [
  { name: "Dashboard", address: "/dashboard", icon: "fa-tachometer-alt" },
  { name: "Cohorts", address: "/dashboard/cohorts", icon: "fa-users" },
  { name: "Assignments", address: "/dashboard/assignments", icon: "fa-book" },
  { name: "Quizzes", address: "/dashboard/quizzes", icon: "fa-question" },
  {
    name: "Submission Status",
    address: "/dashboard/submissionstatus",
    icon: "fa-check",
  },
  {
    name: "Dataset Manager",
    address: "/dashboard/datasets",
    icon: "fa-database",
  },
  { name: "Profile", address: "/dashboard/profile", icon: "fa-user" },
];

const Layout = () => {
  const { loading, role } = useAuth(true); // readOnly: don't clear userSession
  const userRole = role || userSession.role;
  const { pathname } = useLocation();
  const isEvaluating = /^\/dashboard\/(assignments|quizzes|questions)\//.test(pathname);

  if (loading && !userSession.uid) return <div style={{display:'flex',justifyContent:'center',marginTop:'4rem'}}>Loading...</div>;
  if (!userSession.uid) return <Navigate to="/login" />;

  const navItems = userRole === "teacher" ? teacherNavItems : studentNavItems;
  const dashboardName = userRole === "teacher" ? "Teacher Dashboard" : "Student Dashboard";

  return (
    <div id="wrapper" style={{marginBottom:'50px'}}>
      <LeftMenu name={dashboardName} navItems={navItems} />
      <div id="content-wrapper" className="d-flex flex-column">
        <div id="content">
          <div className="container-fluid">
            <Outlet context={{ userRole }} />
          </div>
        </div>
      </div>
      {userRole === "student" && !isEvaluating && <SqlTutorWidget />}
    </div>
  );
};

export default Layout;
